import { render } from "./CompletionRecordList.vue?vue&type=template&id=71f4f583&scoped=true"
import script from "./CompletionRecordList.vue?vue&type=script&lang=js"
export * from "./CompletionRecordList.vue?vue&type=script&lang=js"

import "./CompletionRecordList.vue?vue&type=style&index=0&id=71f4f583&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f4f583"]])

export default __exports__